export default __webpack_public_path__ + "static/media/ufmg.9cfa1737.svg";